import React, { useState, useEffect } from 'react';
const HtmlIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V21.3333C22 22.8061 20.8061 24 19.3333 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { d: "M6.66699 8L7.63644 18.6018L11.9864 20L16.3642 18.6018L17.3337 8H6.66699ZM15.2281 11.4259H10.1225L10.2364 12.7491H15.1142L14.7364 16.7241L12.017 17.4473V17.4554H11.9864L9.24477 16.7241L9.0781 14.6937H10.4031L10.5003 15.7143L11.9864 16.1027L13.4781 15.7143L13.6448 14.0482H9.00866L8.6531 10.1482H15.3503L15.2281 11.4259Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#FF9A70" }),
                React.createElement("stop", { offset: "1", stopColor: "#FF7033" })))));
};
export default HtmlIcon;
